import styled from 'styled-components'

import { NATIVE_BASE_COLORS, COLOR, FONT_SIZE } from '../../../../../themes'

export const StyleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;

  .header-issue-modal {
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.SM};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    padding: 20px 0px 20px 0px;
    text-align: center;
  }
`

export const StyleContent = styled.div`
  padding: 20px 23px 20px 33px;

  .title-field {
    padding: 20px 0px 6px 0px;
  }

  .error-dropdown {
    border: 1px solid red;
  }

  .description-image {
    color: ${COLOR.GRAY_3};
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.TN};
    margin-bottom: 10px;
    padding: 20px 0px 6px 0px;
  }

  .text-area-issue {
    border: 1px solid ${COLOR.GRAY_6};
    padding: 0px 16px 0px 16px;
    border-radius: 4px;
    background-color: ${COLOR.GRAY_4};
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.TN};
    box-sizing: border-box;
    line-height: 36px;
    min-height: 36px;
    outline: none;
  }

  .upload-button { /* From phase 1 */
    display: block;
    cursor: pointer;
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    padding: 4px;
    border-radius:4px;
    line-height: 30px;
    width: 150px;
    height: auto;
    border: none;
    text-align: center;
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.XXS};
    color: ${COLOR.BLACK_1};
  }

  input[type='file'] {
    display: none;
  }

  .preview-images {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 8px;
  }

  .image-layout {
    display: flex;
    align-items: center;
    background-color: ${COLOR.GRAY_1};
  }

  .small-image {
    object-fit: cover;
    width: 52px;
    height: 32px;
    border: 3px solid ${COLOR.WHITE};
    vertical-align: middle;
    margin-left: 5px;
    margin-right: 10px;
  }

  .filename-image {
    border-bottom: 1px solid ${COLOR.BLACK_1};
  }

  .delete-image {
    width: 38px;
    height: 38px;
    cursor: pointer;
  }
`

export const StyleFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 23px 20px 33px;

  .back-button {
    width: 140px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 12px;
    border: 1px solid ${({ colorTheme }) => colorTheme || NATIVE_BASE_COLORS.PRIMARY[200]};
    border-radius: 4px;
    background-color: transparent;
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XS};
    color: ${({ colorTheme }) => colorTheme || NATIVE_BASE_COLORS.PRIMARY[200]};
    cursor: pointer;
    margin-right: 16px;

    &:hover {
      background-color: ${COLOR.HOVER_REPEAT_BOOKING};
    }
  }

  .save-button {
    width: 140px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ colorTheme }) => colorTheme || NATIVE_BASE_COLORS.PRIMARY[200]};
    outline: none;
    border: 1px solid ${({ colorTheme }) => colorTheme || NATIVE_BASE_COLORS.PRIMARY[200]};
    border-radius: 4px;
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XS};
    color: ${NATIVE_BASE_COLORS.TEXT[800]};
    cursor: pointer;
  }
`
